export default __webpack_public_path__ + "static/media/down_arrow2.6faee09d.svg";